function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.324 5.234C8.762 3.566 11.11 3.14 13.32 3.273c2.197.133 4.367.91 5.666 2.67a6.788 6.788 0 01.922 6.253c-.695 1.969-2.543 3.188-4.515 3.92-1.876.697-3.95.824-5.71-.122-1.779-.956-2.845-2.747-3.274-4.705-.46-2.098-.493-4.422.915-6.055z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.287 10.662l1.667 1.667 4.167-4.167",
  stroke: "#fff",
  strokeWidth: 1.667,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.456 5.753l1.33.712-1.33-.712z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.456 5.753l1.33.712",
  stroke: "#000",
  strokeWidth: 1.25,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.313 14.121l1.576-.874-1.576.874z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.313 14.121l1.576-.874",
  stroke: "#000",
  strokeWidth: 1.25,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.165 9.967l1.932.016-1.932-.016z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.165 9.967l1.932.016",
  stroke: "#000",
  strokeWidth: 1.25,
  strokeLinecap: "round"
});

function SvgBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjMyMzkzIDUuMjM0MjNDOC43NjIxOCAzLjU2NjI0IDExLjEwOTkgMy4xMzg3OSAxMy4zMjAzIDMuMjczMDFDMTUuNTE2NSAzLjQwNjM2IDE3LjY4NzQgNC4xODMxNSAxOC45ODYyIDUuOTQyMzVDMjAuMzA3MSA3LjczMTQxIDIwLjY0NzEgMTAuMTAzOSAxOS45MDgyIDEyLjE5NkMxOS4yMTI5IDE0LjE2NDggMTcuMzY0OCAxNS4zODQ0IDE1LjM5MzEgMTYuMTE2N0MxMy41MTc1IDE2LjgxMzIgMTEuNDQzNCAxNi45Mzk3IDkuNjgyNzMgMTUuOTkzNkM3LjkwNDM2IDE1LjAzNzkgNi44MzgwNyAxMy4yNDY5IDYuNDA4NzMgMTEuMjg4NkM1Ljk0ODc4IDkuMTkwNTUgNS45MTYyMyA2Ljg2Njc3IDcuMzIzOTMgNS4yMzQyM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMTAuMjg3NCAxMC42NjIxTDExLjk1NCAxMi4zMjg4TDE2LjEyMDcgOC4xNjIxMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjQ1NTg5IDUuNzUyOTJMMy43ODU1NyA2LjQ2NTI4TDIuNDU1ODkgNS43NTI5MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yLjQ1NTg5IDUuNzUyOTJMMy43ODU1NyA2LjQ2NTI4IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuMzEyNjcgMTQuMTIxTDMuODg5MTYgMTMuMjQ3MUwyLjMxMjY3IDE0LjEyMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yLjMxMjY3IDE0LjEyMUwzLjg4OTE2IDEzLjI0NzEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS4xNjUgOS45NjY4MUwzLjA5NjgyIDkuOTgyNjRMMS4xNjUgOS45NjY4MVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xLjE2NSA5Ljk2NjgxTDMuMDk2ODIgOS45ODI2NCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgBullet as ReactComponent };